// Removes 'Unavailable' button for products that must be inquired about and cleans up other styling in that scenario

let button = document.querySelector("#add-to-cart-form > div.relative.mb-l.md\\:mb-xl > button:nth-child(1)");
let indicator = document.querySelector("#add-to-cart-form > div.relative.mb-l.md\\:mb-xl > button:nth-child(1) > span").innerHTML;
let soldOutThumbnail = document.querySelector("#shopify-section-template--16248941183175__gallery > div > div > div > div.absolute.top-s.lg\\:top-l.left-0.z-50.pointer-events-none");
let purchaseButton = document.querySelector("#add-to-cart-form > div.shopify-payment-button > div > div > div > button.shopify-payment-button__button.shopify-payment-button__button--unbranded.BUz42FHpSPncCPJ4Pr_f.jjzYeefyWpPZLH9pIgyw.RWJ0IfBjxIhflh4AIrUw")
let quoteText = document.querySelector("#rfq-btn-1600 > span");

if (indicator === 'Unavailable') {
  button.style.display="none";
  soldOutThumbnail.style.display="none"

  // Below needs to be fixed
 // quoteText = "Inquire for pricing"
 // console.log(quoteText)
}